import type { DUR } from '@truepill/tpos-types'

export default function keyFromDur(dur: DUR): string {
  return `${dur.status} - ${dur.type} - ${dur.subjects?.[0]?.value ?? '(no value)'} ${dur.directions}`
}
